import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { isMobileOnly } from 'react-device-detect';
import { required } from '../../Helpers/validators';
import CurrencyHelper from '../../Helpers/CurrencyHelper';
import DollarsAndCents from '../DollarsAndCents';
import ConsentCheckField from './ConsentCheckField';
import ExcludedActivitiesCheckField from './ExcludedActivitiesCheckField';
import { Button } from '@jauntin/react-ui';

const btnText = (isLoading) => (
  <>
    {isLoading && (
      <span
        className="spinner-border spinner-border-sm text-light align-middle"
        role="status"
        aria-hidden="true"
      />
    )}
    <span className="mx-2">Purchase</span>
  </>
);
const Purchase = ({
  show,
  isLoading,
  consentEnabled,
  purchaseEnabled,
  purchaseAction,
  total,
  errorResponse,
}) => {
  const divRef = useRef(null);

  const scrollToBottom = () => {
    if ((purchaseEnabled || consentEnabled) && isMobileOnly) {
      divRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(scrollToBottom, [consentEnabled, purchaseEnabled]);

  return (
    show && (
      <>
        <div className="form-row mb-2 pt-2 mt-2 border-top">
          <div className="col font-weight-bold">Total</div>
          <div className="col-auto font-weight-bold">
            <DollarsAndCents
              currency={new CurrencyHelper().setValue(total).convertFromInt()}
            />
          </div>
        </div>

        {(consentEnabled || purchaseEnabled) && (
          <div className="pt-3 mt-3">
            <Field
              show
              disabled={!consentEnabled}
              component={ExcludedActivitiesCheckField}
              validation={[required]}
              name="excludedCheck"
              type="checkbox"
            />
            <Field
              show
              disabled={!consentEnabled}
              component={ConsentCheckField}
              validation={[required]}
              name="consentCheck"
              type="checkbox"
            />
            {errorResponse && (
              <div className="purchase-error">
                Your request could not be processed at this time. Please call{' '}
                <strong>(844) 747-6240</strong> or email us at{' '}
                <a
                  href="mailto:gatherguard@intactinsurance.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>gatherguard@intactinsurance.com</strong>
                </a>
                .
              </div>
            )}
            <Button
              disabled={!purchaseEnabled || isLoading}
              onClick={purchaseAction}
              text={btnText(isLoading)}
              className={`btn-primary d-block mt-3 w-100 btn--summary ${
                (consentEnabled || purchaseEnabled) && isMobileOnly
                  ? 'mb-5'
                  : ''
              }`}
            />
          </div>
        )}
        <div ref={divRef} />
      </>
    )
  );
};
Purchase.propTypes = {
  consentEnabled: PropTypes.bool.isRequired,
  purchaseEnabled: PropTypes.bool.isRequired,
  purchaseAction: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  errorResponse: PropTypes.bool.isRequired,
};

export default Purchase;
